import Loading from 'vue-loading-overlay'

export default {
  Loading
}



// WEBPACK FOOTER //
// ./src/app/tenant/unit/resources/components.js